<template>
<div class="chapter">
<div class="inner_page">
<p class="chapter-hs"><span>PREFACE</span></p>
<p class="normal">In real life when one meets a large family, with all its ramifications of uncles, aunts, and cousins, as well as grandfathers and grandmothers, grandchildren, and great-grandchildren, their friends, servants, and pet animals, it takes time to distinguish them; one does not expect to remember straight away that it is Jane who is married to Bertram, Jack who was born with a club foot, Aunt Margaret who had the unfortunate love affair. One has to get to know them.</p>
<p class="indent"><i>China Court</i> is a novel about five generations of a family, so that, as in real life, there are many names and personalities, but I believe if the reader is a little patient – and can bear not to skip – they will soon become distinct and he will have no need to look at the family tree on the frontispiece.</p>
<p class="indent">Life, Chaucer says, is a ‘thinne subtil knittinge of thinges’; naturally it is difficult to understand.</p>
<p class="right"><span>R.G.</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// frantmatter02.vue?7470af35